import React, { useEffect, useState } from "react";
import { ShimmerCategoryList } from "react-shimmer-effects";
import * as image from "../../resources/images";
import { getAlluserCourses, getCalculatePlanDate, getCapitalized, getLoginType, getSequnceSort } from "../../utils/helper";
import { showModal } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const MyPlanRightPanel = ({ selectedCourse, activityArr, myplan, handleEnroll, handlePlanGoals, isViewPlan, hanldeViewPlan, setIsViewPlan, selectChild }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const {
        loggedInUser,
        defaultChildData
    } = useSelector((state) => state.collections);

    const loginType = getLoginType(loggedInUser);
    const courseEnrollData = location?.state?.enrollResponseObj;

    const [myActivityData, setMyActivityData] = useState(false);

    useEffect(() => {
        if (activityArr?.length > 0) {
            activityArr?.map((data) => {
                handleHideView(data, data?.currentScene, false);
            })
            setMyActivityData(!myActivityData);
        }
    }, [activityArr])

    const handleHideView = (activityObj, currentSceneIndex, result) => {

        activityObj.lessons?.map((lesson, index) => {
            if (index < 3 || index < currentSceneIndex || result) {
                lesson.isShowLesson = true;
            } else {
                lesson.isShowLesson = false;
            }
        })
        setMyActivityData(!myActivityData);
    }

    const showCalenderScreen = () => {
        let getAllPlanCourse = getAlluserCourses(myplan);
        let getUsTimeZone = loggedInUser?.timeZone ? loggedInUser?.timeZone : "US/Eastern";
        let dayOfWeek = []
        let currentDate = new Date();
        for (let i = 0; i < 2; i++) {
            let weekDay = new Date(currentDate).toLocaleString("en-us", { weekday: 'short' });
            dayOfWeek?.push(weekDay);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        let getMyCourses = getCalculatePlanDate(getAllPlanCourse, 30, 2, "", dayOfWeek)
        let holidaysArr = [];
        // myPlan?.holidays?.map((myDate, key) => {
        //  let obj = { date: addDayNameInDate(myDate?.date), name: myDate?.name }
        //  holidaysArr?.push(obj);
        // })
        //  console.log("showCalenderScreen : ", getAllPlanCourse, getMyCourses, dayOfWeek);
        const modalObj = { type: "CalenderVaiew", data: getMyCourses, getUserTimeZone: getUsTimeZone, dayOfWeek: dayOfWeek, holidays: holidaysArr }
        dispatch(showModal(modalObj));
    }

    console.log("myplan : ", selectedCourse, myplan);

    return (
        <div className="rightpannel">
            {(activityArr?.length > 0 || myplan?.isRecommendedPlan) ? (
                <>
                    <div className="panneltitles flexone">
                        <div className="contenttitle w-100">
                            {myplan?.isRecommendedPlan ? (<h3>Recommended Plan</h3>) : (
                                <h3 className="flexone">In Focus
                                    <p className="p1" onClick={() => handlePlanGoals()}>
                                        {!selectedCourse?.isComic && myplan && (
                                            <a href="#">
                                            <i class="fa-solid fa-pen mr-1"></i>
                                            {!selectedCourse?.isDefinedGoal && !selectedCourse?.isCompleted ? "Set Goals" : "Edit Goals"}
                                        </a>
                                        )} 
                                    </p>
                                      {/* <p className="p1" onClick={() => handlePlanGoals()}>
                                        <a href="#">
                                           Upgrade Plan
                                        </a>
                                    </p> */}
                                </h3>)}
                        </div>
                    </div>
                    <div className="rightpanelContent">
                        {(!myplan || (!loginType && !selectedCourse?.isDefinedGoal && !selectedCourse?.isCompleted && !myplan?.isRecommendedPlan)) ? (
                            <div className="locked_Content">
                                {!myplan ? (
                                    <div className="message_box">
                                        <p>
                                            <i class="fa-solid fa-circle-exclamation"></i>
                                        </p>
                                        <p className="p1">Please Select Plan To View It's Contents.</p>
                                        {/* <p className="p1">Click on Start Learning</p> */}
                                    </div>
                                ) : (
                                    <div className="message_box">
                                        <p>
                                            <i class="fa-solid fa-circle-exclamation"></i>
                                        </p>
                                        {courseEnrollData?.records?.length > 0 && courseEnrollData?.recordId === myplan?.id  ? (
                                             <p className="p1">
                                                {/* {courseEnrollData?.message} */}
                                               Congratulations! You’ve successfully enrolled {getCapitalized(selectChild?.firstName)} in {selectedCourse?.name}. 
                                               <br/>
                                                To View It's Contents.
                                               Click on Set Goals
                                            </p>
                                        ) : (
                                            <>
                                                 <p className="p1">Complete Course Setup To View It's Contents.

                                                </p>
                                                <p className="p1">Click on Set Goals

                                                </p>
                                            </>
                                        )}
                                        
                                       
                                    </div>
                                )}

                                {/* <div className="blurcontent">
                                    <img src={image.blurcontent} className="w-100" alt="blurcontent" />
                                </div> */}
                            </div>
                        ) : (
                            <div className="modules_contentList">
                            <p className="mb-3">
                                {myplan?.isRecommendedPlan && isViewPlan && (
                                    <a href="javacript:void(0)" className="a2 mb-3" onClick={()=>setIsViewPlan(false)}><i class="fa-regular fa-angle-left mr-2"></i> Return To Plan</a>
                                )}
                            
                            </p>
                                {myplan?.isRecommendedPlan && (
                                    <>
                                        <h3 className="pdb-2">{!isViewPlan ? myplan?.name : selectedCourse?.name}</h3>
                                        <div className="coursecountinfo">
                                            <ul>
                                                {!isViewPlan && (
                                                    <li>Courses: <span>{myplan?.courseCount}</span></li>
                                                )}
                                                <li>Modules: <span>{myplan?.perCourseModuleCount} {!isViewPlan && "/ Course" }</span></li>
                                                <li>Lessons: <span>{!isViewPlan ? myplan?.lessonCount : selectedCourse?.courseScenesCount}</span></li>
                                            </ul>
                                            {!isViewPlan ? (
                                                    myplan?.planObjectives?.map((objective, index) => (
                                                    <p className="p2" key={index}>{objective}</p>
                                            ))
                                            
                                            ) : (
                                               getSequnceSort(selectedCourse?.objectives)?.map((objective, index) => (
                                                    <p className="p2" key={index}>{objective?.content}</p>
                                                )) 
                                            )} 
                                            <div class="modal-footer mt-3">
                                                <div class="text-right">
                                                    <span onClick={() => hanldeViewPlan(myplan)}>
                                                        <a href="javacript:void(0)" className="mr-3">
                                                            View Schedule
                                                        </a>
                                                    </span>

                                                    <button type="button" class="mybutton" onClick={() => handleEnroll(myplan)}>
                                                        Enroll Now
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {/* {console.log('course: ', myplan)} */}
                                {myplan?.isRecommendedPlan && !isViewPlan && (<h3 className="pdb-2">Courses Included</h3>)}
                                {myplan?.isRecommendedPlan && !isViewPlan ? (
                                    getAlluserCourses(myplan)?.map((course, index) => (
                                        <>
                                            <div className={`modulesitems`} key={index}>
                                                <div className="progess_navigation absolute">
                                                    <span className="circleone">
                                                        <i class="fa-solid fa-check"></i>
                                                    </span>
                                                </div>
                                                <h4>{course?.name}</h4>
                                                <ul>
                                                    {getSequnceSort(course?.activities)?.map((module, key) => (
                                                        <li className={`w-100`} key={key}>
                                                            <span>Module {key + 1}</span>: {module?.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    ))
                                ) : (
                                    <>
                                        {/* <h3 className="pdb-2">{selectedCourse?.name}</h3> */}
                                        {getSequnceSort(activityArr)?.map((module, index) => (
                                            <div className={`modulesitems ${module?.isLock && "locked_modules"}`} key={index}>
                                                <div className="progess_navigation absolute">
                                                    <span className="circleone">
                                                        {(module?.isCompleted || myplan?.isRecommendedPlan) ? (
                                                            <i class="fa-solid fa-check"></i>
                                                        ) : module?.isLock ? (
                                                            <i class="fa-solid fa-lock-keyhole"></i>
                                                        ) : (
                                                            <i class="fa-solid fa-spinner-scale"></i>
                                                        )}
                                                    </span>
                                                </div>
                                                <h4>{module?.name}</h4>
                                                {!module?.isLock && (
                                                    <>
                                                        <ul>
                                                            {getSequnceSort(module?.lessons)?.map((lesson, key) => (
                                                                lesson?.isShowLesson && (

                                                                    <li className={`w-100 ${!myplan?.isRecommendedPlan && !module?.isCompleted && (key + 1 === module?.currentScene ? "Active_lesson" : key + 1 > module?.currentScene ? "inactive_lession" : "")}`} key={key}>
                                                                        <span>Lesson {key + 1}</span>: {lesson?.name}
                                                                    </li>
                                                                )
                                                            ))}

                                                            {/* <li className="w-100"><span>Lesson 2</span>: Your Inner Voice</li>
                                        <li className="w-100"><span>Lesson 3</span>: Self-talk Activity</li> */}
                                                        </ul>

                                                        {module?.lessons?.every(item => item?.isShowLesson) ? (
                                                            <p onClick={() => handleHideView(module, 0, false)}><a href="javascript:void(0);">Show Less</a></p>
                                                        ) : (
                                                            <p onClick={() => handleHideView(module, 0, true)}><a href="javascript:void(0);">Show More</a></p>
                                                        )}

                                                    </>
                                                )}


                                            </div>
                                        ))}
                                    </>
                                )}

                                {/* <div className="modulesitems ">
                        <div className="progess_navigation absolute">
                            <span className="circleone"><i class="fa-solid fa-spinner-scale"></i></span>
                        </div>
                        <h4>Module 2: Self-Talk & Mindset</h4>
                        <ul>
                            <li className="w-100"><span>Lesson 1</span>: What is confidence?</li>
                            <li className="w-100 Active_lesson"><span>Lesson 2</span>: Your Inner Voice</li>
                            <li className="w-100 inactive_lession"><span>Lesson 3</span>: Self-talk Activity</li>
                        </ul>
                    </div>
                    <div className="modulesitems locked_modules">
                        <div className="progess_navigation absolute">
                            <span className="circleone"><i class="fa-solid fa-lock-keyhole"></i></span>
                        </div>
                        <h4>Module 2: Self-Talk & Mindset</h4>
                  
                    </div>
                    <div className="modulesitems locked_modules">
                        <div className="progess_navigation absolute">
                            <span className="circleone"><i class="fa-solid fa-lock-keyhole"></i></span>
                        </div>
                        <h4>Module 4: Building Habits</h4>                  
                    </div> */}
                            </div>)}



                    </div>
                </>) : (
                <ShimmerCategoryList items={3} categoryStyle="STYLE_SIX" />
            )
            }

        </div>
    );
}
export default MyPlanRightPanel;